import { QuizzForm } from "../../components";

const NewQuiz = () => {
  return <QuizzForm />;
};

export default NewQuiz;
